/* nfcommerce — interacciones propias. Sin librerías. */
(function () {
  'use strict';

  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  /* Aparición suave al hacer scroll */
  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.nfc-reveal:not(.nfc-visible)');
    if (!els.length) return;
    if (reducir || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nfc-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('nfc-visible');
          observador.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* Menú móvil de la cabecera */
  function initHeader() {
    var header = document.querySelector('[data-nfc-header]');
    if (!header || header.dataset.nfcListo) return;
    header.dataset.nfcListo = '1';
    var btn = header.querySelector('.nfc-header__menu-btn');
    var panel = header.querySelector('.nfc-header__panel');
    if (!btn || !panel) return;

    function cerrar() {
      header.classList.remove('nfc-abierto');
      document.body.classList.remove('nfc-sin-scroll');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', btn.dataset.abrir || 'Abrir menú');
    }
    function abrir() {
      header.classList.add('nfc-abierto');
      document.body.classList.add('nfc-sin-scroll');
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', btn.dataset.cerrar || 'Cerrar menú');
    }
    btn.addEventListener('click', function () {
      if (header.classList.contains('nfc-abierto')) cerrar(); else abrir();
    });
    panel.addEventListener('click', function (e) { if (e.target.closest('a')) cerrar(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('nfc-abierto')) { cerrar(); btn.focus(); }
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 750) cerrar(); });
  }

  /* Preguntas frecuentes */
  function initFaq(raiz) {
    (raiz || document).querySelectorAll('.nfc-faq__btn').forEach(function (btn) {
      if (btn.dataset.nfcListo) return;
      btn.dataset.nfcListo = '1';
      btn.addEventListener('click', function () {
        var abierto = btn.getAttribute('aria-expanded') === 'true';
        var lista = btn.closest('.nfc-faq__lista');
        if (!abierto && lista && lista.dataset.unaSola === 'true') {
          lista.querySelectorAll('.nfc-faq__btn[aria-expanded="true"]').forEach(function (otro) {
            otro.setAttribute('aria-expanded', 'false');
          });
        }
        btn.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      });
    });
  }

  /* Página de producto: galería, variantes, cantidad y barra fija */
  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-nfc-producto]').forEach(function (cont) {
      if (cont.dataset.nfcListo) return;
      cont.dataset.nfcListo = '1';

      /* Galería */
      var pista = cont.querySelector('.nfc-galeria__pista');
      var minis = cont.querySelectorAll('.nfc-galeria__mini');
      function marcar(i) {
        minis.forEach(function (m, n) { m.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }
      function irA(i, suave) {
        if (!pista) return;
        var diapo = pista.children[i];
        if (!diapo) return;
        pista.scrollTo({ left: diapo.offsetLeft - pista.offsetLeft, behavior: suave === false || reducir ? 'auto' : 'smooth' });
        marcar(i);
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { irA(i); }); });
      if (pista && minis.length) {
        var espera;
        pista.addEventListener('scroll', function () {
          clearTimeout(espera);
          espera = setTimeout(function () {
            var ancho = pista.clientWidth || 1;
            marcar(Math.round(pista.scrollLeft / ancho));
          }, 90);
        }, { passive: true });
      }

      /* Cantidad */
      var cantidad = cont.querySelector('.nfc-cantidad input');
      cont.querySelectorAll('.nfc-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cantidad.value, 10) || 1;
          v = Math.max(1, v + (b.dataset.paso === 'menos' ? -1 : 1));
          cantidad.value = v;
        });
      });
      if (cantidad) cantidad.addEventListener('change', function () {
        var v = parseInt(cantidad.value, 10);
        cantidad.value = !v || v < 1 ? 1 : v;
      });

      /* Variantes */
      var datos = cont.querySelector('[data-nfc-variantes]');
      var variantes = [];
      try { variantes = datos ? JSON.parse(datos.textContent) : []; } catch (e) { variantes = []; }
      var form = cont.querySelector('product-form form') || cont.querySelector('form[data-nfc-form]');
      var inputId = form ? form.querySelector('[name="id"]') : null;
      var boton = cont.querySelector('.nfc-btn--comprar');
      var botonTexto = boton ? boton.querySelector('span') : null;
      var rapida = cont.querySelector('.nfc-compra__rapida');
      var barra = document.querySelector('[data-nfc-barra]');
      var barraBtn = barra ? barra.querySelector('.nfc-btn') : null;
      var textos = {
        comprar: cont.dataset.textoComprar || 'Añadir al carrito',
        agotado: cont.dataset.textoAgotado || 'Agotado',
        nodisp: cont.dataset.textoNoDisponible || 'No disponible'
      };

      function pintarPrecio(v) {
        var html = '';
        if (v) {
          if (v.compare) html += '<s>' + v.compare + '</s>';
          html += '<span>' + v.price + '</span>';
        }
        cont.querySelectorAll('[data-nfc-precio]').forEach(function (el) {
          el.innerHTML = html;
          var ins = el.parentNode.querySelector('[data-nfc-oferta]');
          if (ins) ins.hidden = !(v && v.compare);
        });
        if (barra) {
          var p = barra.querySelector('.nfc-barra__precio');
          if (p) p.textContent = v ? v.price : '';
        }
      }
      function estadoBoton(v) {
        var ok = !!(v && v.available);
        var texto = !v ? textos.nodisp : (v.available ? textos.comprar : textos.agotado);
        if (boton) {
          boton.disabled = !ok;
          if (botonTexto) botonTexto.textContent = texto;
        }
        if (rapida) rapida.hidden = !ok;
        if (barraBtn) { barraBtn.disabled = !ok; barraBtn.textContent = ok ? (barraBtn.dataset.texto || texto) : texto; }
      }
      function elegidas() {
        var sel = [];
        cont.querySelectorAll('[data-nfc-opcion]').forEach(function (f) {
          var pos = parseInt(f.dataset.nfcOpcion, 10);
          var marcado = f.querySelector('input:checked');
          sel[pos] = marcado ? marcado.value : f.dataset.valorUnico;
        });
        return sel;
      }
      function buscar(sel) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i], igual = true;
          for (var j = 0; j < v.options.length; j++) { if (v.options[j] !== sel[j]) { igual = false; break; } }
          if (igual) return v;
        }
        return null;
      }
      function marcarAgotadas(sel) {
        cont.querySelectorAll('fieldset[data-nfc-opcion]').forEach(function (f) {
          var pos = parseInt(f.dataset.nfcOpcion, 10);
          f.querySelectorAll('input').forEach(function (inp) {
            var prueba = sel.slice();
            prueba[pos] = inp.value;
            var v = buscar(prueba);
            inp.classList.toggle('nfc-agotada', !(v && v.available));
          });
        });
      }
      function actualizar(mover) {
        var sel = elegidas();
        var v = buscar(sel);
        cont.querySelectorAll('fieldset[data-nfc-opcion]').forEach(function (f) {
          var marcado = f.querySelector('input:checked');
          var eco = f.querySelector('legend span');
          if (eco && marcado) eco.textContent = marcado.value;
        });
        marcarAgotadas(sel);
        pintarPrecio(v);
        estadoBoton(v);
        if (v && inputId) {
          inputId.value = v.id;
          inputId.dispatchEvent(new Event('change', { bubbles: true }));
          if (window.history && history.replaceState && !window.Shopify.designMode) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            history.replaceState({}, '', url.toString());
          }
          if (mover && v.media && pista) {
            var diapo = pista.querySelector('[data-media-id="' + v.media + '"]');
            if (diapo) irA(Array.prototype.indexOf.call(pista.children, diapo));
          }
        }
      }
      var campos = cont.querySelectorAll('fieldset[data-nfc-opcion] input');
      if (campos.length && variantes.length) {
        campos.forEach(function (inp) { inp.addEventListener('change', function () { actualizar(true); }); });
        marcarAgotadas(elegidas());
      }

      /* Barra fija en móvil */
      if (barra && boton) {
        if (barraBtn) barraBtn.addEventListener('click', function () {
          if (!form) return;
          if (!form.reportValidity || form.reportValidity()) {
            if (form.requestSubmit) form.requestSubmit(); else boton.click();
          } else {
            boton.scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'center' });
          }
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (ent) {
            var e = ent[0];
            var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
            barra.classList.toggle('nfc-visible', pasado);
          }, { threshold: 0 }).observe(boton);
        }
      }
    });
  }

  function initTodo(raiz) {
    initHeader();
    initReveals(raiz);
    initFaq(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }

  /* Editor de Shopify: volver a preparar la sección que se recarga */
  document.addEventListener('shopify:section:load', function (e) {
    var h = document.querySelector('[data-nfc-header]');
    if (h && e.target.contains(h)) delete h.dataset.nfcListo;
    initTodo(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var btn = e.target.querySelector ? e.target.querySelector('.nfc-faq__btn') : null;
    if (btn) btn.setAttribute('aria-expanded', 'true');
  });
})();
